// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import SwiperCarouselController from "./swiper_carousel_controller"
application.register("swiper-carousel", SwiperCarouselController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import RememberOpenController from "./remember_open_controller"
application.register("remember-open", RememberOpenController)

import DropzoneController from "./dropzone_controller"
application.register("dropzone", DropzoneController)
